import { CancelFilled, Reply } from '@interhyp/platform-icons';
import { IconRenderer } from "../../../../helper/components/IconRenderer.js";
import { IconButton } from "../../../iconButton/IconButton.js";
import { Typography } from "../../../typography/Typography.js";
import styles from "./MultiSelectResultItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectResultItem({
  item,
  onRemove,
  dynamicLabel,
  actions
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [!!dynamicLabel && /*#__PURE__*/_jsxs("div", {
      className: styles.dynamicLabel,
      children: [/*#__PURE__*/_jsx(Reply, {
        className: styles.dynamicLabelIcon
      }), /*#__PURE__*/_jsx("div", {
        className: styles.dynamicLabelText,
        children: dynamicLabel(item)
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.listItem,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [item.icon && /*#__PURE__*/_jsx(IconRenderer, {
          icon: item.icon,
          size: "DEFAULT"
        }), /*#__PURE__*/_jsx(Typography, {
          margin: false,
          variant: "p",
          children: item.title
        }), item.subtitle && /*#__PURE__*/_jsx(Typography, {
          margin: false,
          variant: "span",
          className: styles.subtitle,
          children: item.subtitle
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.controls,
        children: [actions?.(item), /*#__PURE__*/_jsx(IconButton, {
          icon: /*#__PURE__*/_jsx(CancelFilled, {}),
          onClick: () => onRemove(item.id),
          className: styles.removeIcon
        })]
      })]
    })]
  });
}